export const projects = [
	{
		img: '/projectpic/crono.png',
		title: 'Clone Cronometer.com',
		des: 'Cronometer is a website and app for counting calories and tracking your diet and health metrics. Also an health and neutrition app it provide a complete solution – no matter what diet you choose to be on. .',
		demo: '',
		live: 'https://cronometer-6018.netlify.app/',
		gitHub: 'https://github.com/Prabin8144/gusty-adjustment-6018',
		technologies: ['Tech Stack:-','React', 'Redux', 'HTML', 'CSS', 'javaScript',"Express.Js","Mongodb"],
	},
	{
		img: '/projectpic/sports.png',
		title: 'Clone Uboric.in',
		des: 'This is a Typical e-commerce website clone. The flow of our website starts from a landing page then to a product page that leads to a description page which takes to cart and payment page. .',
		demo: '',
		live: 'https://boisterous-kringle-c3799d.netlify.app/',
		gitHub: 'https://github.com/Saraswati121/Uboric.git',
		technologies: ['Tech Stack:-','React', 'Redux', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: '/projectpic/dunzo.png',
		title: 'Clone of Dunzo.com',
		des: 'Delivers Groceries & Essentials, Fruits,Vegetables,Food & Medicine supplies in major cities.',
		demo: '',
		live: 'https://sparkly-cheesecake-336e1f.netlify.app/',
		gitHub: 'https://github.com/Rounak-09/Dunzo',
		technologies: ['Tech Stack:-', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: '/projectpic/style.JPEG',
		title: 'Clone of BobbiBrown.com',
		des: 'This is a  Fully e-commerce application where user can get all the Cosmetic Products,That are made in Natural Way.',
		demo: '',
		live: 'https://lucid-kilby-2ad2ec.netlify.app/',
		gitHub: 'https://github.com/Rounak-09/Bobbi_Brown_Cosmetics.git',
		technologies: [ 'HTML', 'CSS', 'javaScript'],
	},
	
	
];
